export default {
  video: {
    desc: '您安全的加密货币硬件钱包',
    preOrderNow: '购买',
    watchNow: '观看了解',
  },

  introduce: {
    title: 'KeyPal，安全性与易用性兼备，优势尽显',
    desc_1: '点任意卡片进一步了解',
    desc_2: '连接',
    desc_3: '安全',
    desc_4: '备份',
    desc_5: 'Passphrase',
    desc_6: '续航',
    desc_7: '电池容量',
    desc_8: '双芯片',
    desc_9: '15宫格',
    desc_10: '多种连接方式，总有一种适合你',
    desc_11: 'NFC + KeyPal Card',
    desc_12: '使用',
    label_1: '支持蓝牙及扫描二维码连接钱包、交易签名',
    label_1_1: '根据不同场景选择不同的连接方式，让硬件钱包的使用更安全、更便捷',
    label_2: 'KeyPal 2 支持 Passphrase',
    label_2_1:
      '使用相同的助记词，搭配不同的 Passphrase 可进入不同的钱包，为钱包再加上一道安全锁',
    label_3: '支持NFC，让备份更简单、更快捷',
    label_3_1: 'KeyPal 2 可通过 NFC 将助记词快读备份到 KeyPal Card',
    label_4: '电池容量更大，从 300mAh 提升至 500mAh',
    label_4_1: '一次充电，可连续运作12小时，让你远离电量不足的焦虑',
    label_5: 'KeyPal 2 采用军工级双芯片设计',
    label_5_1: 'MCU + SE，双芯片设计，安全从核芯开始',
    label_6: '15宫格，让输入、交互更简单',
    label_6_1: '快速输入内容，快速选择功能，不再经历漫长且复杂的过程',
  },

  support: {
    title: '支持百万种加密货币',
    desc_1: '查看支持列表',
  },

  other: {
    title: '其他 KeyPal 产品',
    desc_1: `KeyPal Plus 采用双芯片架构，兼备易用性与安全性，极简设计风格结合坚固的铝合金外壳，打造耐用且高效的加密资产管理体验。`,
    desc_2: `KeyPal Card 支持NFC 通讯，一键轻松保存助记词与私钥，完美结合离线备份与签名功能。银行卡大小设计，便携安全，随时随地保护您的加密资产。`,
    desc_3: `Secret Box 采用304不锈钢材质，具备卓越的耐高温耐腐蚀性能。字母快与凹槽设计，使助记词保存更加简便且持久。A+B面设计，支持12*2、18或者24位助记词存储，为您的加密资产提供长期安全保障。`,
  },

  FAQ: {
    title: 'FAQ',
    desc_1: '点击查看所有常见问题的解答。',
    question_1: '什么是加密钱包?',
    question_2: '为什么我需要一个加密货币钱包？',
    question_3: '硬件钱包和 App 钱包有什么不同？',
    question_4: '如果我丢了设备，加密资产还安全吗？',
    question_5: '这个钱包支持哪些类型的加密货币？',
  },

  discover: {
    title: '选择您最喜爱的KeyPal 颜色',
    desc_1: '探索',
  },

  instructions: {
    title: '教程中心',
    desc: '全方位演示，轻松学 KeyPal 2，让加密资产管理既简单又安全。',
    tabs: {
      hardware: '设备功能',
      activation: '设备教程',
      connect: '连接钱包',
      upgrade: '固件升级',
    },
    hardware: {
      basic: '基础操作',
      power: '开机/关机',
      language: '语言选择',
      button: '按键操作',
      features: '功能介绍',
      security: '安全设置',
      passphrase: 'Passphrase 设置',
      securityOverview: '安全设置介绍',
      verifyDevice: '验证设备',
      asset: '资产管理',
    },
    activation: {
      create: '创建助记词',
      createByDevice: '设备创建助记词',
      import: '导入助记词',
      manualImport: '手动导入',
      keypalCardImport: 'KeyPal Card 导入',
      backup: '备份助记词',
      steelBackup: '抄写/密盒备份',
      keypalCardBackup: 'KeyPal Card 备份',
    },
    connect: {
      bluetooth: '蓝牙连接 TokenPocket',
      connectAndAdd: '连接App并添加钱包地址',
      qrConnect: '扫码连接',
      qrConnectTP: '扫码连接 TokenPocket',
      qrConnectMM: '扫码连接 MetaMask',
      transferReceive: '转账以及收款',
      bluetoothTransfer: '蓝牙转账',
      qrTransfer: '扫码转账',
      receiveHardware: '设备收款',
      receiveApp: 'App收款',
      transfer: '转账',
    },
    upgrade: {
      web: '通过 WEB 网页升级固件',
      bluetooth: '通过蓝牙升级固件',
      mobile: '使用移动端升级',
      troubleshoot: '固件升级疑难',
      webTroubleshoot: '通过 WEB 网页升级固件疑难',
      bluetoothTroubleshoot: '通过蓝牙升级固件疑难',
    },
    relatedVideos: '相关视频',
    playing: '播放中',
  },
};
